module.exports = __webpack_public_path__ + "assets/img/14_1085_big.33f5d0da.jpg";